import { render } from "./TermsCondition.vue?vue&type=template&id=013cb2ed"
import script from "./TermsCondition.vue?vue&type=script&lang=js"
export * from "./TermsCondition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__